import React from 'react';
import Project from './Project';
import './Projects.css';
import info from './data/Data';


const Projects = () => {
   
    return (
         <div className='homescreen'>
            <h2 className="homescreen_title">Lastest Projects</h2>
            <div className="homescreen_products">          
            {info.map(item =>  <Project item={item} />    )}
                   
             </div> 
               
        </div>
      
    )
}

export default Projects
